<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'EQUIPMENTS.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <ng-container>
    <div class="filter-subtitle" [translate]="'EQUIPMENTS.FILTER.WARRANTY_DATE'">Filter by period</div>
    <mat-list>
      <mat-list-item>
        <table width="100%">
          <tr>
            <td width="15%">
              <label class="filter-date-label" [translate]="'EQUIPMENTS.FILTER.FROM'"> From: </label>
            </td>
            <td width="85%">
              <button mat-icon-button (click)="warrantyStartDateLte.open()">
                <i class="angularjs-fuse-icon icon-calendar-today"></i>
              </button>
              <mat-form-field appearance="standard" class="datepicker">
                <input
                  placeholder="{{ 'EQUIPMENTS.FILTER.WARRANTY_FROM' | translate }}"
                  matInput
                  [max]="filtersForm.get('warrantyEndDateGte').value"
                  [matDatepicker]="warrantyStartDateLte"
                  formControlName="warrantyStartDateLte"
                />
                <mat-datepicker-toggle matSuffix [for]="warrantyStartDateLte">
                  <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyStartDateLte></mat-datepicker>

                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidDate')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_DATE' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidPeriod')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_DIFF' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidRange')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_RANGE' | translate }}
                </mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </mat-list-item>
      <mat-list-item>
        <table width="100%">
          <tr>
            <td width="15%">
              <label class="filter-date-label" [translate]="'EQUIPMENTS.FILTER.UNTIL'"> Until: </label>
            </td>
            <td width="85%">
              <button mat-icon-button (click)="warrantyEndDateGte.open()">
                <i class="angularjs-fuse-icon icon-calendar-today"></i>
              </button>
              <mat-form-field appearance="standard" class="datepicker">
                <input
                  placeholder="{{ 'EQUIPMENTS.FILTER.WARRANTY_UNTIL' | translate }}"
                  matInput
                  [min]="filtersForm.get('warrantyEndDateGte').value"
                  [matDatepicker]="warrantyEndDateGte"
                  formControlName="warrantyEndDateGte"
                />
                <mat-datepicker-toggle matSuffix [for]="warrantyEndDateGte">
                  <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyEndDateGte></mat-datepicker>
                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidDate')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_DATE' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyEndDateGte').hasError('invalidPeriod')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_DIFF' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyEndDateGte').hasError('invalidRange')">
                  {{ 'EQUIPMENTS.ERRORS.INVALID_RANGE' | translate }}
                </mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </mat-list-item>
    </mat-list>

    <mat-divider class="mt-16"></mat-divider>

    <div class="filter-subtitle mt-16">
      {{ 'EQUIPMENTS.HEADER.WARRANTY_STATUS' | translate }}
    </div>

    <div class="filter-checkbox mt-16" formArrayName="warrantyStatusIn">
      <mat-checkbox
        *ngFor="let status of WARRANTY_STATUS; let $index = index"
        [ngClass]="status.name + '-fg'"
        labelPosition="before"
        [formControlName]="$index"
      >
        {{ status.name | warrantyStatus }}
      </mat-checkbox>
    </div>
  </ng-container>

  <mat-divider class="mt-16"></mat-divider>
  <input
    class="mt-16 input-legacy"
    formControlName="number"
    name="text"
    placeholder="{{ 'EQUIPMENTS.FILTER.NUMBER' | translate }}"
    autocomplete="off"
  />

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="name"
    name="text"
    placeholder="{{ 'EQUIPMENTS.FILTER.NAME' | translate }}"
    autocomplete="off"
  />

  <mat-divider class="mt-16"></mat-divider>
  <equipment-type-legacy class="mt-16" formControlName="typeId"></equipment-type-legacy>

  <mat-divider class="mt-16"></mat-divider>
  <segment-legacy class="mt-16" formControlName="segmentId"></segment-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-locations-input [control]="filtersForm.get('locations')" [desiredStyle]="desiredStyle"></fc-locations-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>
  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'EQUIPMENTS.FILTER.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'EQUIPMENTS.FILTER.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'EQUIPMENTS.FILTER.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
